<template>
  <span v-if="scenario.elements.length <= 0">
    <v-chip outlined disabled>{{ $t('scenario.empty') }}</v-chip>
  </span>
  <span v-else>
    <element-chip
      v-for="(element, index) in scenario.elements"
      :key="'elt_' + index"
      :element="element"
      :clickable="elementClickable"
      @elementSelected="$emit('elementSelected', $event)"
    />
  </span>
</template>
<script>
import ElementChip from '@/components/global/ElementChip';

export default {
  name: 'elements',

  components: { ElementChip },

  data () {
    return {
    };
  },

  props: {
    scenario: {
      type: Object,
      required: true
    },
    elementClickable: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
  }
}
</script>
<style scoped>
.v-chip--disabled {
  opacity: 0.6;
}
</style>